import React, { useState } from 'react';
import { CheckIcon } from 'lucide-react';
const Register = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    apellido: '',
    email: '',
    password: '',
    confirmPassword: '',
    edad: '',
    intereses: {
      finanzas: false,
      salud: false,
      comunidad: false,
      proposito: false,
      legado: false
    },
    aceptaTerminos: false
  });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const handleChange = e => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    if (type === 'checkbox') {
      if (name.startsWith('intereses.')) {
        const interesName = name.split('.')[1];
        setFormData({
          ...formData,
          intereses: {
            ...formData.intereses,
            [interesName]: checked
          }
        });
      } else {
        setFormData({
          ...formData,
          [name]: checked
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };
  const handleSubmit = e => {
    e.preventDefault();
    // Aquí iría la lógica para enviar los datos a un servidor
    setFormSubmitted(true);
  };
  if (formSubmitted) {
    return <div className="bg-white py-16" data-id="element-548">
        <div className="max-w-md mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-549">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-100 mb-6" data-id="element-550">
            <CheckIcon className="h-8 w-8 text-green-600" data-id="element-551" />
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-552">
            ¡Registro exitoso!
          </h2>
          <p className="text-lg text-gray-600 mb-8" data-id="element-553">
            Gracias por registrarte en "Tu Nueva Vida". Hemos enviado un correo
            de confirmación a {formData.email}.
          </p>
          <a href="/juego" className="inline-block bg-blue-600 text-white hover:bg-blue-700 px-6 py-3 rounded-lg font-medium" data-id="element-554">
            Comenzar a jugar
          </a>
        </div>
      </div>;
  }
  return <div className="bg-white py-12" data-id="element-555">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-556">
        <div className="text-center mb-12" data-id="element-557">
          <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-558">
            Registro para "Tu Nueva Vida"
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-559">
            Únete a nuestra comunidad y comienza tu viaje hacia un retiro con
            propósito
          </p>
        </div>
        <div className="bg-gray-50 rounded-xl p-8 shadow-sm" data-id="element-560">
          <form onSubmit={handleSubmit} data-id="element-561">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-562">
              <div data-id="element-563">
                <label htmlFor="nombre" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-564">
                  Nombre
                </label>
                <input type="text" id="nombre" name="nombre" value={formData.nombre} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" data-id="element-565" />
              </div>
              <div data-id="element-566">
                <label htmlFor="apellido" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-567">
                  Apellido
                </label>
                <input type="text" id="apellido" name="apellido" value={formData.apellido} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" data-id="element-568" />
              </div>
              <div data-id="element-569">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-570">
                  Correo electrónico
                </label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" data-id="element-571" />
              </div>
              <div data-id="element-572">
                <label htmlFor="edad" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-573">
                  Edad
                </label>
                <input type="number" id="edad" name="edad" value={formData.edad} onChange={handleChange} min="18" max="120" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" data-id="element-574" />
              </div>
              <div data-id="element-575">
                <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-576">
                  Contraseña
                </label>
                <input type="password" id="password" name="password" value={formData.password} onChange={handleChange} required minLength="8" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" data-id="element-577" />
              </div>
              <div data-id="element-578">
                <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-579">
                  Confirmar contraseña
                </label>
                <input type="password" id="confirmPassword" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} required minLength="8" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" data-id="element-580" />
              </div>
            </div>
            <div className="mb-8" data-id="element-581">
              <h3 className="text-lg font-medium text-gray-900 mb-3" data-id="element-582">
                ¿Qué aspectos del retiro te interesan más?
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3" data-id="element-583">
                <div className="flex items-center" data-id="element-584">
                  <input type="checkbox" id="intereses-finanzas" name="intereses.finanzas" checked={formData.intereses.finanzas} onChange={handleChange} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-585" />
                  <label htmlFor="intereses-finanzas" className="ml-2 text-gray-700" data-id="element-586">
                    Finanzas y Futuro
                  </label>
                </div>
                <div className="flex items-center" data-id="element-587">
                  <input type="checkbox" id="intereses-salud" name="intereses.salud" checked={formData.intereses.salud} onChange={handleChange} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-588" />
                  <label htmlFor="intereses-salud" className="ml-2 text-gray-700" data-id="element-589">
                    Salud y Bienestar
                  </label>
                </div>
                <div className="flex items-center" data-id="element-590">
                  <input type="checkbox" id="intereses-comunidad" name="intereses.comunidad" checked={formData.intereses.comunidad} onChange={handleChange} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-591" />
                  <label htmlFor="intereses-comunidad" className="ml-2 text-gray-700" data-id="element-592">
                    Vivienda y Comunidad
                  </label>
                </div>
                <div className="flex items-center" data-id="element-593">
                  <input type="checkbox" id="intereses-proposito" name="intereses.proposito" checked={formData.intereses.proposito} onChange={handleChange} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-594" />
                  <label htmlFor="intereses-proposito" className="ml-2 text-gray-700" data-id="element-595">
                    Mentalidad y Propósito
                  </label>
                </div>
                <div className="flex items-center" data-id="element-596">
                  <input type="checkbox" id="intereses-legado" name="intereses.legado" checked={formData.intereses.legado} onChange={handleChange} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-597" />
                  <label htmlFor="intereses-legado" className="ml-2 text-gray-700" data-id="element-598">
                    Conexión y Legado
                  </label>
                </div>
              </div>
            </div>
            <div className="mb-8" data-id="element-599">
              <div className="flex items-start" data-id="element-600">
                <div className="flex items-center h-5" data-id="element-601">
                  <input type="checkbox" id="aceptaTerminos" name="aceptaTerminos" checked={formData.aceptaTerminos} onChange={handleChange} required className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-602" />
                </div>
                <div className="ml-3" data-id="element-603">
                  <label htmlFor="aceptaTerminos" className="text-sm text-gray-700" data-id="element-604">
                    Acepto los{' '}
                    <a href="#" className="text-blue-600 hover:underline" data-id="element-605">
                      términos y condiciones
                    </a>{' '}
                    y la{' '}
                    <a href="#" className="text-blue-600 hover:underline" data-id="element-606">
                      política de privacidad
                    </a>
                  </label>
                </div>
              </div>
            </div>
            <div className="text-center" data-id="element-607">
              <button type="submit" className="bg-blue-600 text-white hover:bg-blue-700 px-8 py-3 rounded-lg font-medium" data-id="element-608">
                Completar registro
              </button>
            </div>
          </form>
        </div>
        <div className="mt-8 text-center text-gray-600" data-id="element-609">
          ¿Ya tienes una cuenta?{' '}
          <a href="#" className="text-blue-600 hover:underline" data-id="element-610">
            Iniciar sesión
          </a>
        </div>
      </div>
    </div>;
};
export default Register;